import { render, staticRenderFns } from "./FiltroUltimoAcesso.vue?vue&type=template&id=dee63be6&"
import script from "./FiltroUltimoAcesso.vue?vue&type=script&lang=js&"
export * from "./FiltroUltimoAcesso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports